import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface BucketArchiveListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
}

const defaultFilters: BucketArchiveListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "uniqueId",
    sortOrder: "asc"
};

export const useBucketArchiveListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<BucketArchiveListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<BucketArchiveListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [location.pathname, history, filters]);

    const setSort = (sort: ListTableSort) => {
        setFilters((prevFilters: BucketArchiveListingFilters) => ({
            ...prevFilters,
            sortBy: sort.by,
            sortOrder: sort.order,
            page: 1
        }));
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: BucketArchiveListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: BucketArchiveListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    return {
        filters,
        setPage,
        setPageSize,
        setSort
    };
};
